/*
 * Abstract parent class for dropdowns using react-select
 */

import React from "react";
import { castDataType, DataType, Mode } from "../common.jsx";
import Selection from './selection.jsx';

export default class ReactSelectSelection extends Selection {
  getSelected() {
    return [Mode.FILL, Mode.VIEW].includes(this.props.mode) ? this.getAnswer() : [];
  }

  viewModeWholeScope() {
    return true;
  }

  onChange = (value) => {
    this.updateAnswer(value);
  };

  getAnswer() {
    return this.getFormattedAnswer(this.getRawAnswer());
  }

  getSelectedOptions(answer) {
    const options = this.getFlatOptions();
    return (answer || this.getSelected())
      .map((a) => options.find((o) => o.value == a))
      .filter((a) => a);
  }

  getFormattedAnswer(answer) {
    return (Array.isArray(answer) ? answer : [answer])
      .map((a) => castDataType(a, this.props.content.dataType || DataType.STRING))
      .filter((a) => a);
  }

  getFormattedPrefillAnswer() {
    const selected = this.getSelectedOptions(this.getFormattedAnswer(this.getPrefilledAnswer()));
    return (Array.isArray(selected) ? selected : [selected])
      .filter(Boolean)
      .map((s) => this.getText(s.label, s.label) || s.label)
      .join(", ");
  }
}
